import React, { useState, useEffect } from 'react'
import {
  TextField,
  Button,
  Typography,
  Paper,
  FormControl
} from '@material-ui/core'
import useStyles from './styles'
import { useNavigate } from 'react-router-dom'
import data from '../../dataPassword.json'
import { URL } from '../../constants/actionTypes'
const PasswordForm = ({ checkLogin }) => {
  const navigate = useNavigate()

  const classes = useStyles()

  const [loginData, setLoginData] = useState({
    password: '',
    loginSuccess: false
  })
  const handleSubmit = async (e) => {
    e.preventDefault()
    data.map((item) => {
      if (item.password === loginData.password) {
        // console.log('login success')
        localStorage.setItem('colorMixingPasswordHipic', true)

        navigate(URL + '/')
      } else {
        console.log('wrong username/password')
      }
    })

    // navigate(URL + '/print', { state: postData })
  }
  useEffect(() => {
    const loginSuccess = JSON.parse(
      localStorage.getItem('colorMixingPasswordHipic')
    )
    // console.log(loginSuccess)
    if (loginSuccess) {
      setLoginData({ ...loginData, loginSuccess })
      navigate(URL + '/')
      //  navigate(0)
    }
  }, [])

  return (
    <Paper className={classes.paper} style={{ maxWidth: '600px' }}>
      <form
        encType='multipart/form-data'
        autoComplete='off'
        noValidate
        className={`${classes.root} ${classes.form}`}
        onSubmit={handleSubmit}
        style={{
          flexWrap: 'wrap',
          justifyContent: 'center',
          minHeight: 'auto'
        }}
      >
        <Typography
          variant='h6'
          style={{ fontWeight: '700', fontSize: '25px', color: '#fff' }}
        >
          Nhập mật khẩu để truy cập
        </Typography>

        <FormControl className={classes.formControl} fullWidth>
          <TextField
            id='demo-simple-select-password'
            className={classes.fileInput}
            name='password'
            variant='outlined'
            label='Password'
            type='password'
            fullWidth
            value={loginData.password}
            onChange={(e) =>
              setLoginData({ ...loginData, password: e.target.value })
            }
            //   onChange={(e) => handleStudentNameChange(e, index)}
          />
        </FormControl>
        <FormControl className={classes.formControl} fullWidth>
          <Button
            className={classes.buttonSubmit}
            variant='contained'
            color='primary'
            size='large'
            type='submit'
            fullWidth
          >
            Đăng Nhập
          </Button>
        </FormControl>
      </form>
    </Paper>
  )
}

export default PasswordForm
